import { useAuth } from '../../../auth/useAuth';
import type { KnowledgeMemberRole } from '../../../types/knowledge';
import { useKnowledgeMembersQuery } from '../queries/useKnowledgeMembersQuery';

export function useCurrentKnowledgeDatabaseRole(
  databaseId: string | undefined,
): KnowledgeMemberRole | null {
  const { user } = useAuth();
  const membersQuery = useKnowledgeMembersQuery(databaseId);

  if (!user?.id || !membersQuery.data) {
    return null;
  }

  return (
    membersQuery.data.find((member) => member.userId === user.id)?.role ?? null
  );
}
